import React from 'react';
import { styled } from '@mui/material';
import { Colors } from 'library';

interface CheckboxProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
    label?: string;
    id?: string;
    size?: 'default' | 'small';
    disabled?: boolean;
}

export function Checkbox({ checked, onChange, label, id, size = 'default', disabled = false }: CheckboxProps) {
    const small = size === 'small';

    if (label) {
        return (
            <LabelWrapper>
                <StyledCheckbox
                    id={id}
                    type="checkbox"
                    checked={checked}
                    onChange={(e) => onChange(e.target.checked)}
                    small={small}
                    disabled={disabled}
                />
                <LabelText small={small}>{label}</LabelText>
            </LabelWrapper>
        );
    }

    return (
        <StyledCheckbox
            id={id}
            type="checkbox"
            checked={checked}
            onChange={(e) => onChange(e.target.checked)}
            small={small}
            disabled={disabled}
        />
    );
}

const LabelWrapper = styled('label')({
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    cursor: 'pointer',
    marginBottom: 0,
});

const LabelText = styled('span')<{ small: boolean }>(({ small }) => ({
    fontSize: small ? 12 : 14,
    fontWeight: 500,
    lineHeight: small ? '16px' : '18px',
    color: 'inherit',
}));

const StyledCheckbox = styled('input')<{ small: boolean }>(({ small }) => ({
    width: small ? 14 : 18,
    height: small ? 14 : 18,
    margin: 0,
    cursor: 'pointer',
    accentColor: Colors.primary,
    flexShrink: 0,
    '&:disabled': {
        cursor: 'not-allowed',
        opacity: 0.5,
    },
}));
